Engravings.bundles.changePicCup = function($cup) {
  $cup.find('[value="Wine Not"]').parent().find('label').html('<img src="https://cdn.shopify.com/s/files/1/0252/8526/3469/files/146x71_wine-not_CUP.png?v=1698271921">')
  $cup.find('[value="Royal"]').parent().find('label').html('<img src="https://cdn.shopify.com/s/files/1/0252/8526/3469/files/146x71_royal_CUP.png?v=1698271921">')
  $cup.find('[value="Grey"]').parent().find('label').html('<img src="https://cdn.shopify.com/s/files/1/0252/8526/3469/files/cup-grey-small.jpg?v=1650967648">')
  $cup.find('[value="Butter"]').parent().find('label').html('<img src="https://cdn.shopify.com/s/files/1/0252/8526/3469/files/cup-butter-small.jpg?v=1650967648">')
  $cup.find('[value="Brown Gold"]').parent().find('label').html('<img src="https://cdn.shopify.com/s/files/1/0252/8526/3469/files/cup-brown-gold.jpg?v=1701133655">')
  $cup.find('[value="Brown Silver"]').parent().find('label').html('<img src="https://cdn.shopify.com/s/files/1/0252/8526/3469/files/cup-brown-mini.jpg?v=1668462301">')
  $cup.find('[value="Black"]').parent().find('label').html('<img src="https://cdn.shopify.com/s/files/1/0252/8526/3469/files/cup-dark-small.jpg?v=1650967648">')
  $cup.find('[value="Matcha"]').parent().find('label').html('<img src="https://cdn.shopify.com/s/files/1/0252/8526/3469/files/cup-matcha-small.jpg?v=1671011403">')
  $cup.find('[value="Rosé"]').parent().find('label').html('<img src="https://cdn.shopify.com/s/files/1/0252/8526/3469/files/equa-cup-rose.jpg?v=1686651663">')
}

Engravings.bundles.changePicBottle = function($bottle) {
  $bottle.find('[value="Wine Not"]').parent().find('label').html('<img src="https://cdn.shopify.com/s/files/1/0252/8526/3469/files/146x71_Timeless-wine-not-600ml.jpg?v=1698271921">')
  $bottle.find('[value="Royal"]').parent().find('label').html('<img src="https://cdn.shopify.com/s/files/1/0252/8526/3469/files/146x71_Timeless-royal-600ml.jpg?v=1698271921">')
  $bottle.find('[value="Off White"]').parent().find('label').html('<img src="https://cdn.shopify.com/s/files/1/0252/8526/3469/files/timeless-600-off-white.jpg?v=1662034031">')
  $bottle.find('[value="Latte"]').parent().find('label').html('<img src="https://cdn.shopify.com/s/files/1/0252/8526/3469/files/timeless-600-latte.jpg?v=1662034031">')
  $bottle.find('[value="Matcha"]').parent().find('label').html('<img src="https://cdn.shopify.com/s/files/1/0252/8526/3469/files/timeless-600-matcha.jpg?v=1662034031">')
  $bottle.find('[value="Dark"]').parent().find('label').html('<img src="https://cdn.shopify.com/s/files/1/0252/8526/3469/files/timeless-600-dark.jpg?v=1662034031">')
  $bottle.find('[value="Lilac"]').parent().find('label').html('<img src="https://cdn.shopify.com/s/files/1/0252/8526/3469/files/timeless-600-lilac.jpg?v=1662034031">')
  $bottle.find('[value="Steel"]').parent().find('label').html('<img src="https://cdn.shopify.com/s/files/1/0252/8526/3469/files/timeless-600-steel.jpg?v=1662034031">')
  $bottle.find('[value="Navy"]').parent().find('label').html('<img src="https://cdn.shopify.com/s/files/1/0252/8526/3469/files/equa-timeless-Single-Wall-Navy-600ml.jpg?v=1663227609">')
  $bottle.find('[value="Splash"]').parent().find('label').html('<img src="https://cdn.shopify.com/s/files/1/0252/8526/3469/files/timeless-Splash_600.jpg?v=1686651662">')
  $bottle.find('[value="Wave"]').parent().find('label').html('<img src="https://cdn.shopify.com/s/files/1/0252/8526/3469/files/timeless-600-wave.jpg?v=1678093907">')
  $bottle.find('[value="Aperol"]').parent().find('label').html('<img src="https://cdn.shopify.com/s/files/1/0252/8526/3469/files/timeless_Aperol_600.jpg?v=1686651662">')
  $bottle.find('[value="Fleurs"]').parent().find('label').html('<img src="https://cdn.shopify.com/s/files/1/0252/8526/3469/files/timeless_DesFleurs_600.jpg?v=1686651662">')
  $bottle.find('[value="Manifesto"]').parent().find('label').html('<img src="https://cdn.shopify.com/s/files/1/0252/8526/3469/files/timeless-manifesto.jpg?v=1701131522">')
  $bottle.find('[value="Stardust"]').parent().find('label').html('<img src="https://cdn.shopify.com/s/files/1/0252/8526/3469/files/timeless-stardust.jpg?v=1701131522">')
  $bottle.find('[value="Sandro Telling Stories x Equa"]').parent().find('label').html('<img src="https://cdn.shopify.com/s/files/1/0252/8526/3469/files/timeless-sandro.jpg?v=1701131523">')
  $bottle.find('[value="Avocado"]').parent().find('label').html('<img src="https://cdn.shopify.com/s/files/1/0252/8526/3469/files/timeless-600-avo.jpg?v=1662113974">')
  $bottle.find('[value="Set Match"]').parent().find('label').html('<img src="https://cdn.shopify.com/s/files/1/0252/8526/3469/files/timeless-600-setmatch.jpg?v=1678093907">')
  $bottle.find('[value="Flwr Pwr"]').parent().find('label').html('<img src="https://cdn.shopify.com/s/files/1/0252/8526/3469/files/timeless-600-flwr-pwr.jpg?v=1662113974">')
  $bottle.find('[value="Sunny Side Up"]').parent().find('label').html('<img src="https://cdn.shopify.com/s/files/1/0252/8526/3469/files/146x71_Timeless-sunny-side-up.jpg?v=1698413600">')
  $bottle.find('[value="Juice Bar"]').parent().find('label').html('<img src="https://cdn.shopify.com/s/files/1/0252/8526/3469/files/146x71_Timeless-juice-bar.jpg?v=1698413600">')
  $bottle.find("[value=\"C'est La Vie\"]").parent().find('label').html('<img src="https://cdn.shopify.com/s/files/1/0252/8526/3469/files/timeless-600-cestlavie.jpg?v=1696321467">')
  $bottle.find('[value="La Mer"]').parent().find('label').html('<img src="https://cdn.shopify.com/s/files/1/0252/8526/3469/files/timeless-lamer.jpg?v=1701131522">')
  $bottle.find('[value="Après Swim"]').parent().find('label').html('<img src="https://cdn.shopify.com/s/files/1/0252/8526/3469/files/timeless-600-apresswim.jpg?v=1696321468">')
}

Engravings.bundles.init = function() {

  if ('bottle-cup' == g_product.handle) {
    g_product.tags.push('timeless-wine-not-bundle', 'cup-wine-not-bundle')
    Engravings.bundles.changePicBottle($('[data-index=option1]'))
    Engravings.bundles.changePicCup($('[data-index=option2]'))
  }

  if ('matcha-cup' == g_product.handle) {
    g_product.tags.push('cup-wine-not')
    Engravings.bundles.changePicCup($('[data-index=option1]'))    
  }

  if ('cup-cup' == g_product.handle) {
    g_product.tags.push('cup-wine-not-bundle', 'cup-wine-not-bundle')
    Engravings.bundles.changePicCup($('[data-index=option1]'))
    Engravings.bundles.changePicCup($('[data-index=option2]'))
  }
  
  if ('recharge-bottle' == g_product.handle) {
    g_product.tags.push('timeless-wine-not-bundle')
    Engravings.bundles.changePicBottle($('[data-index=option2]'))
  }
  
}


EngravingView.prototype.setPreviewVars = function() {
  let { tag, type } = this

  //
  // Bundles
  //
  if ('royal-duo' == g_product.handle) {
    if ('cup-royal-bundle' == tag) {
      this.handle = 'cup'
      this.selector = `[data-engravingtype=${type}] [data-tag=${tag}]`
      this.identTpl = 'cup-royal'        
    }
    else if ('timeless-royal-bundle' == tag) {
      this.handle = 'timeless600'
      this.selector = LONG_BODY == type ? `[data-engravingtype=${type}] .timeless600 [data-tag=timeless-royal]` : `[data-engravingtype=${type}] [data-tag=timeless-royal]`
      this.identTpl = 'timeless-royal(600)'
    }
  }
  
  else if ('santas-sip' == g_product.handle) {
    if ('cup-wine-not-bundle' == tag) {
      this.handle = 'cup'
      this.selector = `[data-engravingtype=${type}] [data-tag=${tag}]`
      this.identTpl = 'cup-wine-not'
    }
    else if ('timeless-wine-not-bundle' == tag) {
      this.handle = 'timeless600'
      this.selector = LONG_BODY == type ? `[data-engravingtype=${type}] .timeless600 [data-tag=timeless-wine-not]` : `[data-engravingtype=${type}] [data-tag=timeless-wine-not]`
      this.identTpl = 'timeless-wine-not(600)'
    }
  }

  else if ('holiday-harmony' == g_product.handle) {
    if ('cup-grey-bundle' == tag) {
      this.handle = 'cup'
      this.selector = `[data-engravingtype=${type}] [data-tag=${tag}]`
      this.identTpl = 'cup-grey'
    }
    else if ('timeless-stardust-bundle' == tag) {
      this.handle = 'timeless600'
      this.selector = LONG_BODY == type ? `[data-engravingtype=${type}] .timeless600 [data-tag=timeless-stardust]` : `[data-engravingtype=${type}] [data-tag=timeless-stardust]`
      this.identTpl = 'timeless-stardust(600)'
    }
  }
    

  else if ('xmas-wellness' == g_product.handle) {
    if ('cup-wine-not-bundle' == tag) {
      this.handle = 'cup'
      this.selector = `[data-engravingtype=${type}] [data-tag=${tag}]`
      this.identTpl = 'cup-wine-not'
    }
    else if ('timeless-royal-bundle' == tag) {
      this.handle = 'timeless600'
      this.selector = LONG_BODY == type ? `[data-engravingtype=${type}] .timeless600 [data-tag=timeless-royal]` : `[data-engravingtype=${type}] [data-tag=timeless-royal]`
      this.identTpl = 'timeless-royal(600)'
    }
  }

  else if ('candy-cane' == g_product.handle) {
    if ('cup-rose-bundle' == tag) {
      this.handle = 'cup'
      this.selector = `[data-engravingtype=${type}] [data-tag=${tag}]`
      this.identTpl = 'cup-rose'
    }
    else if ('cup-grey-bundle' == tag) {
      this.handle = 'cup'
      this.selector = `[data-engravingtype=${type}] [data-tag=${tag}]`
      this.identTpl = 'cup-grey'
    }
  }

  else if ('bottle-cup' == g_product.handle) {
    let selectedVariant = g_getSelectedVariants()[this.parent.index]

    // Timeless color
    if (0 == this.parent.index) {
      type = SHORT_CAP
      let tagMap = {
        'Wine Not': 'timeless-wine-not-bundle',
        'Royal': 'timeless-royal-bundle',
        'Off White': 'timeless-white-bundle',
        'Latte': 'timeless-latte-bundle',
        'Matcha': 'timeless-matcha-bundle',
        'Dark': 'timeless-dark-bundle',
        'Lilac': 'timeless-lilac-bundle',
        'Steel': 'timeless-steel-bundle',
        'Navy': 'timeless-navy-bundle',
        'Splash': 'timeless-splash-bundle',
        'Wave': 'timeless-wave-bundle',
        'Aperol': 'timeless-aperol-bundle',
      }
      
      tag = this.tag = tagMap[selectedVariant]
      let variant = this.handle = 'timeless600'
      this.selector = `[data-engravingtype=${type}] [data-tag=${tag}]`
      this.identTpl = 'timeless(600){variant}'
    }

    // Cup color
    else if (1 == this.parent.index) {
      type = SHORT_BODY
      let tagMap = {
        'Wine Not': 'cup-wine-not-bundle',
        'Royal': 'cup-royal-bundle',
        'Grey': 'cup-grey-bundle',
        'Butter': 'cup-butter-bundle',
        'Brown Silver': 'cup-brown-bundle',
        'Brown Gold': 'cup-brown-bundle',
        'Black': 'cup-black-bundle',
        'Matcha': 'cup-matcha-bundle',
        'Rosé': 'cup-rose-bundle',
      }
      
      tag = this.tag = tagMap[selectedVariant]
      let variant = this.handle = 'cup'
      this.selector = LONG_BODY == type ? `[data-engravingtype=${type}] .${variant} [data-tag=${tag}]` : `[data-engravingtype=${type}] [data-tag=${tag}]`
      this.identTpl = 'cup{variant}'
    }
  }

  else if ('recharge-bottle' == g_product.handle) {
    let selectedVariant = g_getSelectedVariants()[1]
    // console.log(selectedVariant)
    type = SHORT_CAP

    let tagMap = {
      'Wine Not': 'timeless-wine-not-bundle',
      'Royal': 'timeless-royal-bundle',
      'Off White': 'timeless-white-bundle',
      'Latte': 'timeless-latte-bundle',
      'Matcha': 'timeless-matcha-bundle',
      'Fleurs': 'timeless-fleurs',
      'Dark': 'timeless-dark-bundle',
      'Lilac': 'timeless-lilac-bundle',
      'Steel': 'timeless-steel-bundle',
      'Navy': 'timeless-navy-bundle',
      'Splash': 'timeless-splash-bundle',
      'Wave': 'timeless-wave-bundle',
      'Aperol': 'timeless-aperol-bundle',
      'Stardust': 'timeless-stardust',
      'Sandro Telling Stories x Equa': 'timeless-sandro',
      'Manifesto': 'timeless-manifesto',
      'Avocado': 'timeless-avocado',
      'Set Match': 'timeless-setmatch',
      'Flwr Pwr': 'timeless-flwrpwr',
      'Sunny Side Up': 'timeless-sunnysideup',
      'Juice Bar': 'timeless-juicebar',
      "C'est La Vie": 'timeless-cestlavie',
      'La Mer': 'timeless-lamer',
      'Après Swim': 'timeless-apreswim',
    }

    tag = this.tag = tagMap[selectedVariant]
    let variant = this.handle = 'timeless600'
    this.selector = LONG_BODY == type ? `[data-engravingtype=${type}] .${variant} [data-tag=${tag}]` : `[data-engravingtype=${type}] [data-tag=${tag}]`
    let variantSlug = selectedVariant.replaceAll(' ', '-').replaceAll("'", '').replaceAll('"', '').toLowerCase()
    if (variantSlug == 'sandro-telling-stories-x-equa') variantSlug = 'sandro-off-white'
    // console.log(variantSlug)
    this.identTpl = 'timeless(600)(' + variantSlug + ')'
  }

  else if ('cup-cup' == g_product.handle) {
    let selectedVariant = g_getSelectedVariants()[this.parent.index]

    let tagMap = {
      'Wine Not': 'cup-wine-not-bundle',
      'Royal': 'cup-royal-bundle',
      'Grey': 'cup-grey-bundle',
      'Butter': 'cup-butter-bundle',
      'Brown Silver': 'cup-brown-bundle',
      'Brown Gold': 'cup-brown-bundle',
      'Black': 'cup-black-bundle',
      'Matcha': 'cup-matcha-bundle',
      'Rosé': 'cup-rose-bundle',
    }

    tag = this.tag = tagMap[selectedVariant]
    let variant = this.handle = 'cup'
    this.selector = `[data-engravingtype=${type}] [data-tag=${tag}]`
    this.identTpl = 'cup{variant}'
  }

  
  else if ('matcha-cup' == g_product.handle) {
    let selectedVariant = g_getSelectedVariants()[this.parent.index]

    let tagMap = {
      'Wine Not': 'cup-wine-not',
      'Royal': 'cup-royal',
      'Grey': 'cup-grey',
      'Butter': 'cup-butter',
      'Brown Silver': 'cup-brown',
      'Brown Gold': 'cup-brown',
      'Black': 'cup-black',
      'Matcha': 'cup-matcha',
      'Rosé': 'cup-rose',
    }
    
    tag = this.tag = tagMap[selectedVariant]
    let variant = this.handle = 'cup'
    this.selector = `[data-engravingtype=${type}] [data-tag=${tag}]`
    this.identTpl = 'cup{variant}'
  }
  
  // 1 product, 2 engravings
  else if ('apreswim-bottle-beach-bag' == g_product.handle) {
    let selectedVariant = g_getSelectedVariant()
    if ("Après Swim" == selectedVariant) tag = this.tag = 'timeless-apreswim'
    if ("C'est la vie" == selectedVariant) tag = this.tag = 'timeless-cestlavie'
    let variant = this.handle = 'timeless600'
    this.selector = LONG_BODY == type ? `[data-engravingtype=${type}] .${variant} [data-tag=${tag}]` : `[data-engravingtype=${type}] [data-tag=${tag}]`
    this.identTpl = '{tag}'
  }

  // 1 product, 2 engravings
  else if ('sandro-telling-stories-x-equa-water-bottle' == g_product.handle) {
    let selectedVariant = g_getSelectedVariant()
    if ("Off White" == selectedVariant) tag = this.tag = 'timeless-sandro-white'
    if ("Dark" == selectedVariant) tag = this.tag = 'timeless-sandro-dark'
    let variant = this.handle = 'timeless600'
    this.selector = `[data-engravingtype=${type}] [data-tag=${tag}]`
    this.identTpl = '{tag}600'
  }

  // 1 product, 2 engravings
  else if ('zalutali-pjesnik-x-equa-water-bottle' == g_product.handle) {
    let selectedVariant = g_getSelectedVariant()
    if ("Off White" == selectedVariant) tag = this.tag = 'timeless-zalutali-white'
    if ("Wine Not" == selectedVariant) tag = this.tag = 'timeless-zalutali-winenot'
    let variant = this.handle = 'timeless600'
    this.selector = `[data-engravingtype=${type}] [data-tag=${tag}]`
    this.identTpl = '{tag}600'
  }      

  else if ('hydration-bundle' == g_product.handle) {
    let variant = this.handle = 'timeless600'
    this.selector = LONG_BODY == type ? `[data-engravingtype=${type}] .${variant} [data-tag=${tag}]` : `[data-engravingtype=${type}] [data-tag=${tag}]`
    this.identTpl = '{tag}{variant}'
  }

  else if ('2025-plan-hydrate-duo' == g_product.handle) {
    this.tag = 'carry-forest'
    this.handle = 'carrycup'
    this.selector = `[data-engravingtype=${type}] [data-tag=${tag}]`
    this.identTpl = '{tag}'   
  }

  else if ('carry-festa-della-mamma' == g_product.handle) {
    let selectedVariant = g_getSelectedVariants()
    let selectedColor = selectedVariant[0]
    this.handle = 'carrycup'
    type = SHORT_BODY

    tag = this.tag = 'carry-mothersday-it-' + selectedColor.replaceAll(' ', '-').toLowerCase()
    this.selector = `[data-engravingtype=${type}] [data-tag=${tag}]`
    this.identTpl = 'carry-mothers-day-it('+selectedVariant[0]+')(' + selectedVariant[1] + ')'
    this.identTpl = this.identTpl.replaceAll(' ', '-').replaceAll("'", '').replaceAll('"', '').toLowerCase()
    console.log(this.identTpl)
    console.log('type & tag', type, tag)
  }

  //
  // Default products
  //

  else if (['engraving-cap-only'].includes(tag)) {
    // Timeless caps and Caps product must have this tag: "engraving-cap-only"
    // I removed it from caps to disable the engraving on glass caps
    let selected = g_getSelectedVariant()
    let varid = 0
    g_product.variants.forEach(variant => {
      if (variant.title == selected) varid = variant.id
    })
    this.handle = 'cap'
    this.selector = `[data-engravingtype=${type}] [data-varid="${varid}"]`
    this.variant = $(this.selector).data('cap')
    this.identTpl = (g_product.tags.includes('timeless-cap') ? 'timeless-' : '') + 'cap{variant}'
    if (varid == 0) console.log('ENGRAVING ERROR: No id for cap variant.')
  }

  else if (g_product.type == 'EQUA Cup') {
    this.handle = 'cup'
    this.selector = `[data-engravingtype=${type}] [data-tag=${tag}]`
    this.identTpl = '{tag}{variant}'
  }
    
  else if (g_product.type == 'Carry Cup') {
    this.handle = 'carrycup'
    this.selector = `[data-engravingtype=${type}] [data-tag=${tag}]`
    this.identTpl = '{tag}'
  }

  else if (g_product.type == 'Stainless Steel Bottles') {
    this.handle = 'stainless'
    this.selector = LONG_BODY == type ? `[data-engravingtype=${type}] .stainless [data-tag=${tag}]` : `[data-engravingtype=${type}] [data-tag=${tag}]`      
    this.identTpl = 'stainless_{tag}{variant}'
  }

  else if (g_product.type == 'Smart Water Bottles') {
    this.handle = 'smart'
    this.selector = LONG_BODY == type ? `[data-engravingtype=${type}] .smart [data-tag=${tag}]` : `[data-engravingtype=${type}] [data-tag=${tag}]`
    this.identTpl = 'smart_{tag}{variant}'
  }

  else if (g_product.type == 'Timeless Water Bottle' || g_product.type == 'Timeless Water Bottle DW') {
    let dw = g_product.tags.includes('double-wall') ? '_dw' : ''
    let variant = 'timeless' + (g_getSelectedVariant() || '')
    this.handle = variant + dw
    this.selector = LONG_BODY == type ? `[data-engravingtype=${type}] .${variant + dw} [data-tag=${tag}]` : `[data-engravingtype=${type}] [data-tag=${tag}]`
    this.identTpl = '{tag}'+(dw.replace('_dw', '{dw}'))+'{variant}'
  }

  else if (g_product.type.indexOf('Glass Bottles') == 0) {
    this.handle = 'glass'
    this.selector = `[data-engravingtype=${type}] [data-tag="${tag}"]`
    this.identTpl = 'glass-bottle{tag}'
  }

  else if (g_product.type == 'Kids bottle') {
    this.handle = 'kids-bottle'
    this.selector = `[data-engravingtype=${type}] [data-tag="${tag}"]`
    this.identTpl = '{tag}'
  }

  else if (g_product.type.toLowerCase() == 'big cup') {
    this.handle = 'big-cup'
    this.selector = `[data-engravingtype=${type}] [data-tag="${tag}"]`
    this.identTpl = '{tag}'
  }

  else if (g_product.type.toLowerCase() == 'big cup') {
    this.handle = 'big-cup'
    this.selector = `[data-engravingtype=${type}] [data-tag="${tag}"]`
    this.identTpl = '{tag}'
  }

  else {
    console.log('==== Alert ====: Product type not recognised')
  }

  // products with more than 1 variants
  let varId = g_getSelectedVariantId()
  if ('carry-cup-lido-mood-polako' == g_product.handle) {
    if ("58286702657923" == varId) this.tag = 'carry-mood-polako-hrvaski'
    if ("58286702625155" == varId) this.tag = 'carry-mood-naizi-slovenski'
  }
  if ('equa-cup-pomodoro-sunce-i-kava' == g_product.handle) {
    if ("58287588475267" == varId) this.tag = 'cup-sunce-i-kava-hrvaski'
    if ("58287588442499" == varId) this.tag = 'cup-sonce-in-kava-slovenski'
  }
  if ('thermo-timeless-sorbetto-bottle-mood-polako' == g_product.handle) {
    if ("58287689466243" == varId) this.tag = 'timeless-mood-polako-hrvaski'
    if ("58287689433475" == varId) this.tag = 'timeless-mood-naizi-slovenski'
  }


  // console.log('type', type)
  // console.log('tag', tag)
  // console.log('selector', this.selector)
  // console.log('handle', this.handle)
  
  if (INLINE_BODY == this.type) {
    this.userTextLimit = 30
  }  
}


/*
____________________________
 
  @ONLOAD - INIT ENGRAVINGS
____________________________
 
*/
$(document).ready(function() {

  // quick fix for products with variants and no tags
  
  let varId = g_getSelectedVariantId()
  if ('equa-cup-pomodoro-sunce-i-kava' == g_product.handle) {
    if ("58287588475267" == varId) g_product.tags.push('cup-sunce-i-kava-hrvaski')
    if ("58287588442499" == varId) g_product.tags.push('cup-sonce-in-kava-slovenski')
  }
  if ('carry-cup-lido-mood-polako' == g_product.handle) {
    if ("58286702657923" == varId) g_product.tags.push('carry-mood-polako-hrvaski')
    if ("58286702625155" == varId) g_product.tags.push('carry-mood-naizi-slovenski')
  }
  if ('thermo-timeless-sorbetto-bottle-mood-polako' == g_product.handle) {
    if ("58287689466243" == varId) g_product.tags.push('timeless-mood-polako-hrvaski')
    if ("58287689433475" == varId) g_product.tags.push('timeless-mood-naizi-slovenski')
  }


  // Register all available engravings.
  Engravings.registerEngravings()
  Engravings.collectAllEngravingProductIds()

  // Exit if we are not on the product page
  if (!g_product) return

  // Add a second engraving
  // if (g_product.handle == 'equa-cup-royal') {
  //   g_product.tags.push('timeless-royal')
  // }
  
  Engravings.bundles.init()

  // Build the engravings forms
  Engravings.productTags().forEach((tag, i) => {

      let configForm = {
        $container: $('.engraving-form:eq('+i+')'),
        tag: tag,
        index: i
      }
      Engravings.AllEngravingForms.push(new EngravingForm(configForm))

  })

  // Init Personalise button
  if (Engravings.AllEngravingForms.length) Engravings.personaliseButton = new PersonaliseButton()
  
  Engravings.refreshAll()

  // Some products have 2 sets of variants
  $('.variant-wrapper input[data-index=option2]').click(function() {
    Engravings.refreshAll()
  })
})